export default __webpack_public_path__ + "static/media/callcenter_icon.c9c6770a.svg";